import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-book-credit-note-report-very-briefly-officer',
  // standalone: true,
  // imports: [],
  templateUrl: './book-credit-note-report-very-briefly-officer.component.html',
  styleUrl: './book-credit-note-report-very-briefly-officer.component.scss'
})
export class BookCreditNoteReportVeryBrieflyOfficerComponent {
  filterData: any[] = [];
   currentDate= new Date();
   TotalBillAmt: number = 0;
   TotalCreditNoteAmt: number = 0;
   startDate: string = '';
   endDate: string = '';
   reportType: string = '';
   officerepwise: any;
   repName: any;
  booksellerwise: any;
 
   constructor(
     private dialogRef: MatDialogRef<BookCreditNoteReportVeryBrieflyOfficerComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any,
     private service: DigisubservicesService
   ) {}
 
   ngOnInit(): void {
 
     this.startDate = this.data['startDate'];
     this.endDate = this.data['endDate'];
        this.officerepwise = this.data?.office_rep_name || this.data?.officerepwise || ''; // ✅ fetch from dialog data if passed
      this.repName = this.data?.rep_name || this.data?.repName || '';
              this.booksellerwise = this.data?.booksellerwise || this.data?.booksellerwise || '';
     this.reportType = this.data['reportType'];
     this.getCreditNoteData();
   }
 
   // ✅ Fetch API Data
   getCreditNoteData() {
     const req = {
       
       start_crdtnote_date: this.startDate,
       end_crdtnote_date: this.endDate,
        office_rep_name: this.officerepwise,
         rep_name: this.repName,
       bill_no: this.data['bill_no'] || '',
       book_seller_name: this.booksellerwise,
       crdtnote_no: this.data['crdtnote_no'] || '',
       book: this.data['book'] || ''
     };
 
     this.service.getBookCreditNoteReport(req).subscribe({
       next: (res: any) => {
         this.filterData = res || [];
         this.calculateTotals();
       },
       error: (err) => {
         console.error('Error fetching Book Credit Note data:', err);
       }
     });
   }
 
   // ✅ Calculate Totals
   calculateTotals(): void {
     this.TotalBillAmt = 0;
     this.TotalCreditNoteAmt = 0;
 
     this.filterData.forEach((item) => {
       this.TotalBillAmt += parseFloat(item.bill_amount) || 0;
       this.TotalCreditNoteAmt += parseFloat(item.crdtnote_total) || 0;
     });
   }
 
   // ✅ Print function
 printPage4() {
   const printContent = document.getElementById('print-section');
   const WindowPrt = window.open('', '', 'width=1400,height=900');
 
   WindowPrt.document.write(`
     <html>
       <head>
         <title>Book Payment Receipt Report</title>
         <style>
           /* ===== PAGE SETUP ===== */
           @page {
             size: A3 landscape;
             margin: 5mm;
             margin-left: 20mm;
           }
 
           html, body {
             margin: 0;
             padding: 0;
             font-family: Arial, sans-serif;
             font-size: 13px;
             color: #000;
             -webkit-print-color-adjust: exact !important;
             print-color-adjust: exact !important;
           }
 
           /* ===== TABLE STRUCTURE ===== */
           table {
             width: 100%;
             border-collapse: collapse;
             border-spacing: 0;
             table-layout: auto;
             word-wrap: break-word;
           }
 
           th, td {
             border: 1px solid black;
             border-left: 1px solid black !important;
             border-right: 1px solid black !important;
             padding: 6px 8px;
             vertical-align: middle;
             white-space: nowrap; /* ✅ Prevents content breaking */
           }
 
           th:first-child,
           td:first-child {
             border-left: 1px solid black !important;
           }
 
           th:last-child,
           td:last-child {
             border-right: 1px solid black !important;
           }
 
           th {
             background-color: #f1f1f1 !important;
             text-align: center;
             font-weight: bold;
             white-space: nowrap; /* ✅ Prevents header text breaking */
           }
 
           tr:nth-child(even) td {
             background-color: #fafafa;
           }
 
           /* ===== HEADER SECTION ===== */
           .header-table {
             width: 100%;
             border-bottom: 1px solid black;
             background-color: #f8f9fa !important;
           }
 
           .header-table td {
             padding: 10px 6px;
             font-weight: bold;
             font-size: 16px;
           }
 
           /* ===== COLOR ROWS ===== */
           tr.office-row td {
             background-color: #e6f2ff !important;
             font-weight: bold;
             text-align: center;
           }
 
           tr.rep-row td {
             background-color: #f9f9f9 !important;
             font-weight: bold;
           }
 
           tr.rep-total td {
             background-color: #fff7e6 !important;
             font-weight: bold;
           }
 
           tr.office-total td {
             background-color: #ffe6e6 !important;
             font-weight: bold;
           }
 
           /* ===== GRAND TOTAL ROW ===== */
           .grand-total-row td {
             background-color: #d9ead3 !important;
             font-weight: bold;
             text-align: right;
           }
 
           /* ===== PRINT OPTIMIZATION ===== */
           tr, td, th {
             page-break-inside: avoid !important;
           }
 
           table {
             page-break-after: auto;
           }
 
           thead {
             display: table-header-group;
           }
 
           tfoot {
             display: table-row-group !important;
           }
 
           @media print {
             body {
               -webkit-transform: scale(0.95);
               transform: scale(0.95);
               transform-origin: top left;
             }
 
             .noPrint {
               display: none !important;
             }
           }
         </style>
       </head>
       <body>
         ${printContent?.innerHTML}
       </body>
     </html>
   `);
 
   WindowPrt.document.close();
   WindowPrt.focus();
 
   setTimeout(() => {
     WindowPrt.print();
     WindowPrt.close();
   }, 600);
 }
 
   // ✅ Export to Excel
   exportExcel(fileName: string): void {
     const element = document.getElementById('print-section');
     if (!element) return;
 
     const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Report');
     XLSX.writeFile(wb, `${fileName}.xlsx`);
   }
 }
 